import React, { FC } from 'react'
import styled from 'styled-components'

import { SanityAccountDashboardPageFragment } from '../../../../../graphql/gatsby'
import FeaturedProductsBanner from '../../../../sanity-page/FeaturedProductsBanner'
import { SliderConfig } from '../../../../sanity-page/FeaturedProductsSlider'

export interface DashboardFeaturedProductsBannerProps {
  featuredProductsBanner: Extract<
    NonNullable<
      NonNullable<SanityAccountDashboardPageFragment['sanityAccountDashboardPage']>['content']
    >[number],
    { __typename?: 'SanityFeaturedProductsBanner' }
  >
}

const sliderConfig: SliderConfig = {
  dots: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
      },
    },
  ],
}

const StyledFeaturedProductsBanner = styled(FeaturedProductsBanner)`
  border-radius: 8px;
  padding-left: 0;
  padding-right: 0;
  background: transparent;

  @media (max-width: 991px) {
    // Override styles for the product cards
    & > div > div > div {
      flex: 1 0 48%;
      height: unset;
    }
  }

  @media (min-width: 992px) {
    background: ${({ theme }) => theme.colors.coolGray.cool100};
    padding-left: 90px;
    padding-right: 90px;

    & > div > div .slick-list {
      padding: 10px 0;
    }
  }
`

export const DashboardFeaturedProductsBanner: FC<DashboardFeaturedProductsBannerProps> = ({
  featuredProductsBanner,
}) => {
  return <StyledFeaturedProductsBanner {...featuredProductsBanner} config={sliderConfig} />
}
